import { render, staticRenderFns } from "./VehicleData.vue?vue&type=template&id=8be973a6&scoped=true"
import script from "./VehicleData.vue?vue&type=script&lang=js"
export * from "./VehicleData.vue?vue&type=script&lang=js"
import style0 from "./VehicleData.vue?vue&type=style&index=0&id=8be973a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be973a6",
  null
  
)

export default component.exports